function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Story-editor-Copy",
  transform: "translate(-83.000000, -78.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(60.000000, 60.000000)"
}, React.createElement("path", {
  d: "M25.0760325,19.0364675 L25.0342479,19.0782521 C23.9104052,20.2020948 23.9094118,22.0238974 25.0320284,23.1489651 L36.3583333,34.5 L25.0320284,45.8510349 C23.9094118,46.9761026 23.9104052,48.7979052 25.0342479,49.9217479 L25.0760325,49.9635325 C26.2007424,51.0882424 28.0242576,51.0882424 29.1489675,49.9635325 L44.6125,34.5 L29.1489675,19.0364675 C28.0242576,17.9117576 26.2007424,17.9117576 25.0760325,19.0364675 Z",
  id: "Mask-Copy",
  transform: "translate(33.806250, 34.500000) rotate(-180.000000) translate(-33.806250, -34.500000) "
}))));

var SvgUndo = function SvgUndo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "21px",
    height: "33px",
    viewBox: "0 0 21 33",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUndo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/undo.d40817de.svg";
export { ForwardRef as ReactComponent };